const nav = {
  top: [
    {
      name: 'Home',
      url: '/dashboard/home',
      icon: 'Home'
    },
    {
      name: 'Gerenciar Arquivos',
      url: '/dashboard/documents',
      icon: 'Folder',
      componentName: 'DocumentListPage'
    },
    {
      name: 'Gerenciar Usuários',
      url: '/dashboard/users',
      icon: 'User',
      componentName: 'UserListPage'
    },
    {
      name: 'WebGIS',
      url: '/dashboard/web-gis',
      icon: 'Map',
      componentName: 'WebGisPage'
    },
    {
      name: 'Nuvem de Pontos',
      url: '/dashboard/point-cloud',
      icon: 'Cloud',
      componentName: 'PointCloudPage'
    },
    {
      name: 'Instrumentação',
      url: '/dashboard/instrumentation',
      icon: 'Link',
      componentName: 'InstrumentationPage'
    },
    {
      name: 'Importar Arquivos',
      url: '/dashboard/upload-documents',
      icon: 'Upload',
      componentName: 'UploadDocumentPage'
    },
  ],
};

export default nav;
